import { render, staticRenderFns } from "./ExTextInput.vue?vue&type=template&id=08327bcb&scoped=true"
import script from "./ExTextInput.vue?vue&type=script&lang=js"
export * from "./ExTextInput.vue?vue&type=script&lang=js"
import style0 from "./ExTextInput.vue?vue&type=style&index=0&id=08327bcb&prod&lang=css"
import style1 from "./ExTextInput.vue?vue&type=style&index=1&id=08327bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08327bcb",
  null
  
)

export default component.exports